<template>
  <BaseDrawer
    shrink
    :is-open="isOpen"
    @close="emit('close')"
  >
    <div class="flex flex-col space-y-3 px-3 pb-3">
      <ActionButtonSecondary @click="onClickZReport(false)">
        Visa & Mastercard
      </ActionButtonSecondary>
      <ActionButtonSecondary @click="onClickZReport(true)">
        Amex
      </ActionButtonSecondary>
    </div>
  </BaseDrawer>
</template>

<script setup lang="ts">
import { IReports } from "@/androidPlugins/IReports"
import { logZReport } from "@/services/reconciliation/logZReport"
import { formatPositiveZReport } from "@/services/reconciliation/formatPositiveZReport"
import * as Sentry from "@sentry/vue"
import { HandledError } from "@/utils/HandledError"
import { IPrinter } from "@/androidPlugins/IPrinter"
import { ApiError } from "@/services/api"

defineProps<{
  isOpen: boolean
}>()

const emit = defineEmits<{
  (event: "close"): void
}>()

const { startLoading, stopLoading } =
  usePageBlockingLoading()
const { printingSupported } = useDevice()
const router = useRouter()
const route = useRoute()

const onClickZReport = async (isAmex: boolean) => {
  startLoading()
  try {
    const report = await IReports.generateZReport({
      isAmex,
    })
    toast.success("Z report successful")

    const printable = formatPositiveZReport(report)
    if (printingSupported.value) {
      await IPrinter.printStr({ str: printable })
    }

    const { id: zReportId } = await logZReport(
      printable,
      report
    )

    router.push({
      name: "settingsZReportDetail",
      params: {
        zReportId: zReportId,
      },
      state: {
        backRoute: {
          name: route.name,
          params: route.params,
        },
      },
    })

    emit("close")
  } catch (error) {
    if (error instanceof HandledError) return
    if (error instanceof ApiError) {
      toast.error(
        "Failed to save Z report receipt to server"
      )
      return
    }
    Sentry.captureException(error)
    toast.error("Failed to generate Z Report")
  } finally {
    stopLoading()
  }
}
</script>
